import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ts0013',
    ecrans: ['00-2']
});
